import convertToEnglishNumber from './convertToEnglishNumber';

const convertTimeStampToPersianFormat = (date) => {
  let finalValue = '';
  let faDate = convertToEnglishNumber(new Date(date).toLocaleDateString('fa'));
  let dateList = faDate.split('/');
  finalValue =
    dateList[2] +
    ' ' +
    convertMonthToPersianName(dateList[1]) +
    ' ' +
    dateList[0];
  return finalValue;
};

const convertMonthToPersianName = (month) => {
  switch (month) {
    case '1':
      return 'فروردین';
    case '2':
      return 'اردیبهشت';
    case '3':
      return 'خرداد';
    case '4':
      return 'تیر';
    case '5':
      return 'مرداد';
    case '6':
      return 'شهریور';
    case '7':
      return 'مهر';
    case '8':
      return 'آبان';
    case '9':
      return 'آذر';
    case '10':
      return 'دی';
    case '11':
      return 'بهمن';
    case '12':
      return 'اسفند';

    default:
      break;
  }
};

export default convertTimeStampToPersianFormat;
